<template>
  <div>
    <div class="main-content">
      <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
      <div class="main-content-inner">
        <div class="breadcrumbs ace-save-state" id="breadcrumbs">
          <ul class="breadcrumb">
            <li>
              <i class="ace-icon fa fa-home home-icon"></i>
              <a href="#/">メインメニュー</a>
            </li>
            <li>
              <a href="#/relation">外部ログインサービス利用設定</a>
            </li>
            <li class="active">ログインユーザー登録</li>
          </ul><!-- /.breadcrumb -->
        </div>
        <div class="page-header">
            <h3>ログインユーザー登録</h3>
        </div><!-- /.page-header -->
        <div class="page-content">
          <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
          <div class="row">
            <div class="col-xs-12">
              <div class="alert alert-danger" v-if="error">
                {{ message }}
              </div>
              <div class="alert alert-success" v-if="sucessStatus">
                {{ message }}
              </div>
              <!-- PAGE CONTENT BEGINS -->
                <table id="relation-table" class="table  table-bordered table-hover dataTable" >
                  <thead>
                    <tr>
                      <th style="width: 30%;">ログインID</th>
                      <th style="width: 30%;">ALLIGATEユーザーID</th>
                      <th style="width: 25%;">外部ログインサービス</th>
                      <th style="width: 15%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style="width: 30%;">
                        <input type="text" id="new-email" v-model="newEmail" class="form-control input-sm">
                      </td>
                      <td style="width: 30%;">
                        <div>
                          <multiselect
                            v-model="newUser"
                            id="newUser"
                            :options="userList"
                            placeholder=""
                            :maxHeight="140"
                            label="userId"
                            :custom-label="customLabel"
                            :show-labels="false"
                            track-by="userId"
                            :disabled="isDisabled"
                            tag-placeholder="ゲートグループの追加">
                            <span slot="noResult" style="color:red">userIdが見つかりません。</span>
                            <template slot="option" slot-scope="props">
                              <div class="option__desc"><span class="option__small">{{ props.option.userId }}</span></div>
                            </template>
                            </multiselect>
                        </div>
                      </td>
                      <td style="width: 25%;">
                        <select v-model="loginServiceType" class="form-control loginServiceType">
                          <option v-for="item in OwnerFederatedLoginService" :key="item.relationOwnerFederatedLoginServiceId" :value="item.relationId">{{item.cognitoIdProviderName}}</option>
                        </select>
                      </td>
                      <td class="center" style="width: 15%">
                        <button @click="addRelation()" style="padding: 5px 28px;" class="btn-cusstom green-btn" :disabled ="!isFederatedLoginService"><i class="fa fa-plus"></i>  登録</button>
                      </td>
                    </tr>
                    <tr v-for="(item, index) in realtionsUserList" :key="index">
                      <td>
                        <span v-if="!relationIdRowEditing[item.relationId]">{{item.federatedLoginEmail}}</span>
                      </td>
                      <td>
                          <span v-if="!relationIdRowEditing[item.relationId]" >{{item.userId}}</span>
                      </td>
                      <td >{{getFederatedLoginServiceProviderName(item.relationOwnerFederatedLoginServiceId)}}</td>
                      <td class="center">
                        <button  @click="openConfirmModal(item.relationId)" v-if="!relationIdRowEditing[item.relationId]" class="btn-cusstom black-btn" :disabled ="!isFederatedLoginService">削除</button>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="row" v-if="pages > 0">
                    <div class="col-xs-12">
                      <div class="dataTables_paginate paging_simple_numbers">
                        <paginate
                          :page-count="pages"
                          :page-range="3"
                          :margin-pages="2"
                          :click-handler="handleCurrentChange"
                          :prev-text="'<<'"
                          :next-text="'>>'"
                          :container-class="'pagination'"
                          :page-class="'page-item'">
                        </paginate>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="pages === 1" style="margin-bottom:55px">
                  &nbsp;
                </div>
                <!-- PAGE CONTENT ENDS -->
            </div><!-- /.row -->
          </div><!-- /.page-content -->
        </div>
      <div id="question" class="modal fade" tabindex="-1">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
              <h3 class="smaller lighter frofile-title no-margin">ユーザー統合ログインサービスを削除する</h3>
            </div>
            <div class="modal-body">
              <span class="progress-question"> ユーザー結合ログインサービスを削除しますか？</span>
            </div>
            <div class="modal-footer">
              <button id="yes-choice" class="btn btn-sm btn-danger pull-right" data-dismiss="modal" @click="yesChoice()" style="width: 100px;">削除</button>
            </div>
          </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
      </div>
    </div><!-- /.main-content -->
    <a href="javascript:void(0)" class="float" id="menu-share" v-if ="isFederatedLoginService === 'true'">
    <i class="fa fa-plus my-float"></i>
    </a>
    <ul class="add_btn_list" v-if ="isFederatedLoginService === 'true'">
      <li>
        <router-link :to="{ name: 'relation-user-federated-login-service-import'}" class="adduserExport">
          <i class="ace-icon glyphicon glyphicon-upload my-float"></i>
        </router-link>
        <div class="label-container-export" style="top: 175px;">
          <div class="label-text">CSV一括登録</div>
          <i class="fa fa-play label-arrow"></i>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import * as Config from '../../config'
import multiselect from 'vue-multiselect'
export default {
  components: { multiselect },
  data () {
    return {
      error: '',
      loading: false,
      message: '',
      sucessStatus: '',
      userList: [],
      updateUserid: '',
      updateEmail: '',
      newUser: '',
      newEmail: '',
      deleteRelationId: '',
      pageSizeList: 25,
      pages: 1,
      currPage: 1,
      isDisabled: true,
      realtionsUserList: [],
      relationIdRowEditing: {},
      loginServiceType: '',
      OwnerFederatedLoginService: [],
      isFederatedLoginService: false
    }
  },
  mounted () {
    this.getUsers(1)
    this.getOwnerFederatedLoginService()
    this.getFederatedLoginRelation()
    this.isFederatedLoginService = localStorage.isFederatedLoginService
  },
  methods: {
    editRelationIdRow (relationIdRow, updateEmail, updateUserid) {
      this.relationIdRowEditing = []
      this.updateEmail = updateEmail
      this.updateUserid = {userId: updateUserid}
      this.relationIdRowEditing[relationIdRow] = true
    },
    getUsers (page) {
      this.$http.get(Config.USERS_LIST_API + '?limit=1000&page=' + page + '&sortKey=asc:userId&isValid=true')
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            response.body.users.forEach(element => {
              this.userList.push({userId: element.userId})
            })
            if (response.body.maxRecords > response.body.endRecord) {
              this.getUsers(page + 1)
            } else {
              this.isDisabled = false
              console.log(this.userList)
            }
          } else {
            this.loading = false
            this.userList = null
          }
        })
        .catch((error) => {
          this.loading = false
          console.log(error)
        })
    },
    getFederatedLoginRelation () {
      this.loading = true
      this.$http.get(Config.USER_FEDERATED_LOGIN_SERVICE_API + '?limit=' + this.pageSizeList + '&page' + this.currPage)
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.loading = false
            response.body.relationsUserFederatedLoginService.forEach(element => {
              this.realtionsUserList.push(element)
            })
            this.pages = Math.ceil((response.body.maxRecords) / this.pageSizeList)
            console.log(response)
            this.loading = false
          } else {
            this.loading = false
            this.realtionsUserList = []
          }
        })
        .catch((error) => {
          this.loading = false
          this.realtionsUserList = []
          console.log(error)
        })
    },
    getOwnerFederatedLoginService () {
      this.$http.get(Config.OWNER_FEDERATED_LOGIN_SERVICE_API)
        .then((response) => {
          console.log(response)
          this.OwnerFederatedLoginService = response.body.relationsOwnerFederatedLoginService
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getFederatedLoginServiceProviderName (relationsOwnerFederatedLoginServiceId) {
      const relation = this.OwnerFederatedLoginService.filter(element => element.relationId === relationsOwnerFederatedLoginServiceId)
      if (relation.length > 0) {
        return relation[0].cognitoIdProviderName
      }
    },
    handleCurrentChange (val) {
      this.currPage = val
      this.getFederatedLoginRelation()
      window.scrollTo(0, 0)
    },
    addRelation () {
      var canSubmit = this.validateBeforeSubmit()
      var Infor = {
        userId: this.newUser.userId,
        federatedLoginEmail: this.newEmail,
        relationOwnerFederatedLoginServiceId: this.loginServiceType
      }
      if (canSubmit) {
        this.loading = true
        this.$http.post(Config.USER_FEDERATED_LOGIN_SERVICE_API, Infor)
          .then(response => {
            console.log(response)
            this.realtionsUserList = []
            this.getFederatedLoginRelation()
            this.currPage = 1
            this.loading = false
            this.message = 'ログインユーザーが登録されました。'
          })
          .catch((error) => {
            switch (error.status) {
              case 401:
                if (error.body.message === 'The incoming token has expired') {
                  this.message = ''
                } else {
                  this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                }
                break
              case 400:
                this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 500:
                this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
            this.error = true
            // this.getFederatedLoginRelation()
            // this.realtionsUserList = []
            // this.currPage = 1
            this.loading = false
          })
      }
    },
    deleteRelation () {
      this.loading = true
      this.$http.delete(Config.USER_FEDERATED_LOGIN_SERVICE_API + '/' + this.deleteRelationId)
        .then(response => {
          console.log(response)
          this.realtionsUserList = []
          this.getFederatedLoginRelation()
          this.currPage = 1
          this.loading = false
          this.message = '選択項目が削除されました。'
        })
        .catch((error) => {
          switch (error.status) {
            case 401:
              if (error.body.message === 'The incoming token has expired') {
                this.message = ''
              } else {
                this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              }
              break
            case 400:
              this.message = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 500:
              this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              this.message = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              this.message = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
          this.error = true
          this.loading = false
        })
    },
    customLabel (user) {
      if (user.userId.length > 50) {
        return user.userId.substring(0, 49) + '...'
      }
      return user.userId
    },
    validateBeforeSubmit () {
      this.error = false
      this.message = ''
      var validEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/.test(this.newEmail)
      if (!validEmail) {
        this.error = true
        $('#new-email').addClass('error')
        this.message = '正しいメールアドレスを入力してください。'
        return false
      } else {
        $('#new-email').removeClass('error')
      }
      var userID = 0
      if (this.newUser !== '' && this.newUser.userId !== null && this.newUser.userId !== '') {
        userID = this.newUser.userId
      }
      var validUserID = /^[a-zA-Z0-9@.!#$%&'*+/=?^_`{|}~-]{4,96}$/.test(userID)
      if (!validUserID) {
        $('.multiselect').addClass('error')
        this.message = 'ユーザーIDは必須です。'
        this.error = true
        return false
      } else {
        $('.multiselect').removeClass('error')
      }
      var validType = /^[0-9a-fA-F-]{36}$/.test(this.loginServiceType)
      if (!validType) {
        $('.loginServiceType').addClass('error')
        this.message = '外部ログインサービスは必須です。'
        this.error = true
        return false
      } else {
        $('.loginServiceType').removeClass('error')
      }
      return true
    },
    yesChoice () {
      // Delete
      this.deleteRelation()
    },
    openConfirmModal (relationId) {
      this.deleteRelationId = relationId
      $('#question').modal({
        backdrop: 'static'
      })
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style >
#relation-table .multiselect__tags {
    min-height: 20px !important;
    height: 31px;
    border-radius: unset;
    padding: 5px 40px 0px 8px;
    margin-top: 0px;
}
#relation-table .multiselect__tags input{
    border: none;
    padding-top: 0px;
    height: 15px;
}
#relation-table .multiselect__select:before {
    top: 62%;
}
#relation-table .multiselect {
    min-height: 30px;
}
#relation-table>tbody>tr>td {
    vertical-align: middle;
    padding: 5px;
    font-size: 16px;
}
.invisibility {
  visibility: hidden
}
.multiselect.error , .loginServiceType.error  {
    border: 1px solid red;
}
.btn-cusstom[disabled], .btn-cusstom[disabled].active, .btn-cusstom[disabled]:active, .btn-cusstom[disabled]:focus, .btn-cusstom[disabled]:hover {
    background: #ccc !important;
    border: 5px solid #ccc !important;
    white-space: normal;
}
</style>



// WEBPACK FOOTER //
// src/views/login-service/RelationUserFederatedLoginService.vue